import { render, staticRenderFns } from "./MeetingCaption.vue?vue&type=template&id=489ae49e&scoped=true"
import script from "./MeetingCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./MeetingCaption.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./MeetingCaption.vue?vue&type=style&index=0&id=489ae49e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ae49e",
  null
  
)

export default component.exports